<template>
  <el-dialog :visible.sync="dialogFormVisible" :title="titles[updateType]" :before-close="close">
    <el-form ref="form" label-width="120px" :model="initForm" :rules="rules">
      <el-form-item label="存储区域" prop="cloud">
        <el-input v-model="initForm.cloud" placeholder="请输入存储区域名称，不能重复添加"></el-input>
      </el-form-item>

      <el-form-item label="存储介质类型" prop="storage_type">
        <el-select v-model="initForm.storage_type" placeholder="请选择">
        <el-option
          v-for="item in storageTypes"
          :label="item"
          :key="item"
          :value="item"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="bucket名称" prop="bucket_name">
        <el-input v-model="initForm.bucket_name" placeholder="bucket名称"></el-input>
      </el-form-item>

      <el-form-item label="EndPoint" prop="end_point">
        <el-input v-model="initForm.end_point" placeholder="EndPoint"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">提交</el-button>
      <el-button @click="$emit('close')" type="info">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { StorageTypes } from "@/components/Index/data.js";

export default {
  props: {
    initForm: {},
    updateType: {}
  },
  data() {
    return {
      dialogFormVisible: true,
      rules: {
        cloud: [{required: true, message: "请输入存储区域名称(英文简写)", trigger: "blur"}],
        storage_type: [{required: true, message: "请选择存储介质类型", trigger: "blur"}],
        bucket_name: [{required: true, message: "请输入 bucket 名称", trigger: "blur"}],
        end_point: [{required: false, message: "请输入 endpoint", trigger: "blur"}]
      },
      titles: {
        add: "新增软件包云存储",
        edit: "编辑软件包云存储"
      },
      storageTypes: StorageTypes
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        var method = "";
        var url = "";
        var msg = "操作失败";
        var formData = {
              cloud: this.initForm.cloud,
              storage_type: this.storageTypes.indexOf(this.initForm.storage_type),
              bucket_name: this.initForm.bucket_name,
              end_point: this.initForm.end_point
            };
        if (!valid) {alert("请检查输入是否正确！"); return false;};
        this.dialogFormVisible = false;
        if (this.updateType === "add") {
          method = "post";
          url = "device-rom/storage/";
          msg = "添加成功";
        } else if (this.updateType === "edit") {
          method = "patch";
          url = "device-rom/storage/" + this.initForm.id + "/";
          msg = "编辑成功";
        } else{
          return false;
        };
        this.$http[method](
          url,
          formData,
          () => {
            this.$baseNotice.message(msg);
            this.$emit("close");
            this.$emit("update");
          }
        )
      });
    }
  }
};
</script>
